<template>
  <div>
    <div class="header header-light dark-text" id="header">
      <div class="container">

        <div class="row">
          <div class="col-12 p-0">
            <nav id="navigation" :class="windowWidth > 991 ? 'navigation navigation-landscape' : 'navigation navigation-portrait'" aria-label="Hovednavigation">
              <div class="nav-header">
                <router-link class="nav-brand" to="/" aria-label="Gå til forsiden" title="Forside">
                  <img :src="logo" class="logo" :alt="siteName || 'Logo'" decoding="async" loading="eager" />
                </router-link>

                <div class="nav-toggle" role="button" tabindex="0" aria-label="Åbn luk navigation" :aria-expanded="toggle ? 'true' : 'false'" aria-controls="primary-menu" @click="toggle = !toggle"></div>
              </div>

              <div
                  id="primary-menu"
                  class="nav-menus-wrapper"
                  :class="{ 'nav-menus-wrapper-open': toggle}"
                  :style="windowWidth > 991 ? null : {'left': toggle ? '0%' : '-100%'}"
                  :aria-hidden="windowWidth > 991 ? null : (!toggle ? 'true' : 'false')"
                  :inert="windowWidth > 991 ? null : (!toggle ? '' : null)"
              >
                <span class="nav-menus-wrapper-close-button" role="button" tabindex="0" aria-label="Luk menu" @click="toggle = !toggle">✕</span>

                <ul class="nav-menu" role="menubar">
                  <li v-for="category in Categories" :key="category.id" :class="current === '/shop/' + category.name ? 'active' : ''">
                    <router-link
                        @click="toggle = false"
                        :to="'/shop/' + category.name + '/' +category.subCategories[0].urlSlug"
                        :aria-current="current === '/shop/' + category.name + '/' +category.subCategories[0].urlSlug ? 'page' : null"
                        :aria-label="'Gå til ' + category.displayname"
                        :title="category.displayname"
                    >
                      {{ category.displayname }}
                    </router-link>
                  </li>

                  <li v-if="windowWidth <= 991" :class="{'active': current.startsWith('/kunstnere/')}">
                    <a
                        href="#"
                        role="button"
                        :aria-expanded="mobileArtistsOpen ? 'true' : 'false'"
                        aria-haspopup="true"
                        @click.prevent="mobileArtistsOpen = !mobileArtistsOpen"
                        class="d-flex justify-content-between align-items-center"
                    >
                      KUNSTNERE
                      <span :class="mobileArtistsOpen ? 'lni lni-chevron-up' : 'lni lni-chevron-down'" aria-hidden="true"></span>
                    </a>

                    <ul
                        v-if="mobileArtistsOpen"
                        class="nav-dropdown nav-submenu d-block position-relative w-100 shadow-none border-top"
                        role="menu"
                        aria-label="Undermenu kunstnere"
                    >
                      <li v-for="category in Categories" :key="category.id" :class="current === '/kunstnere/' + category.name ? 'active' : ''">
                        <router-link
                            :to="'/kunstnere/' + category.name"
                            :aria-current="current === '/kunstnere/' + category.name ? 'page' : null"
                            :aria-label="'Se ' + category.branche"
                            :title="category.branche"
                            @click="toggle = false; mobileArtistsOpen = false"
                        >
                          {{ category.branche }}
                        </router-link>
                      </li>
                      <li :class="current === '/kunstnere/alle' ? 'active' : ''">
                        <router-link
                            :to="'/kunstnere/alle'"
                            :aria-current="current === '/kunstnere/alle' ? 'page' : null"
                            aria-label="Se alle kunstnere"
                            title="Se alle kunstnere"
                            @click="toggle = false; mobileArtistsOpen = false"
                        >
                          <b>Se alle kunstnere</b>
                        </router-link>
                      </li>
                    </ul>
                  </li>

                </ul>

                <ul class="nav-menu nav-menu-social align-to-right" aria-label="Søgning">
                  <li v-if="windowWidth > 991" :class="[current === '/kunstnere' || current.startsWith('/kunstnere/') ? 'active' : '']">
                    <router-link to="#" role="button" aria-haspopup="true" :aria-expanded="current === '/kunstnere' || current.startsWith('/kunstnere/') ? 'true' : 'false'" aria-label="Kunstnere menu" title="Kunstnere">KUNSTNERE</router-link>
                    <ul class="nav-dropdown nav-submenu" style="z-index: 100;" role="menu" aria-label="Undermenu kunstnere">
                      <li v-for="category in Categories" :key="category.id" :class="current === '/kunstnere/' + category.name ? 'active' : ''">
                        <router-link
                            :to="'/kunstnere/' + category.name"
                            :aria-current="current === '/kunstnere/' + category.name ? 'page' : null"
                            :aria-label="'Se ' + category.branche"
                            :title="category.branche"
                            @click="toggle = false"
                        >
                          {{ category.branche }}
                        </router-link>
                      </li>
                      <li :class="current === '/kunstnere/alle' ? 'active' : ''">
                        <router-link
                            :to="'/kunstnere/alle'"
                            :aria-current="current === '/kunstnere/alle' ? 'page' : null"
                            aria-label="Se alle kunstnere"
                            title="Se alle kunstnere"
                            @click="toggle = false"
                        >
                          <b>Se alle kunstnere</b>
                        </router-link>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </nav>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-12">
            <form role="search" class="w-100 position-relative" aria-label="Global søgning" @submit.prevent="handleSearchSubmit">
              <div class="input-group input-group-lg">
                <input
                    type="search"
                    placeholder="Søg efter kunstnere, kategorier eller værker..."
                    class="form-control"
                    aria-label="Søg i hele butikken"
                    v-model="searchTerm"
                />
                <button type="submit" class="btn btn-default" aria-label="Start søgning">
                  <i class="lni lni-search-alt" aria-hidden="true"></i>
                  <span class="d-none d-sm-inline ms-2">Søg</span>
                </button>
              </div>

              <ul
                  v-if="artistResults.length > 0 || groupedResults.length > 0 || isSearchingArtists"
                  class="dropdown-menu show w-100 shadow-lg mt-1"
                  style="position: absolute; z-index: 1050;"
                  aria-label="Søgeresultater"
              >
                <template v-if="groupedResults.length > 0">
                  <li><h6 class="dropdown-header">KATEGORIER</h6></li>
                  <template v-for="(group, groupIndex) in groupedResults" :key="group.categoryId">
                    <li v-if="groupIndex > 0"><hr class="dropdown-divider"></li>

                    <li v-for="result in group.results" :key="result.id">
                      <router-link
                          :to="result.url"
                          class="dropdown-item d-flex justify-content-between align-items-center"
                          @click="selectResult(result)"
                      >
                        <span class="d-flex align-items-center" :class="{'fw-bold': result.type === 'category'}">
                          <i v-if="result.type !== 'category'" class="lni lni-arrow-right me-2"></i>
                          {{ result.displayname }}
                        </span>
                      </router-link>
                    </li>
                  </template>
                </template>

                <li v-if="artistResults.length > 0 && groupedResults.length > 0"><hr class="dropdown-divider"></li>

                <li v-if="isSearchingArtists" class="dropdown-item text-muted">
                  <div class="d-flex align-items-center">
                    <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    Søger efter kunstnere...
                  </div>
                </li>

                <template v-if="artistResults.length > 0">
                  <li><h6 class="dropdown-header">KUNSTNERE</h6></li>
                  <li v-for="artist in artistResults" :key="artist.artistId">
                    <router-link
                        :to="'/kunstner/' + artist.artistSubdomain"
                        class="dropdown-item p-3"
                        :aria-label="'Se profilside for ' + (artist.artistName || 'kunstner')"
                        :title="'Profilside for ' + (artist.artistName || 'kunstner')"
                        @click="selectArtist(artist)"
                    >
                      <div class="d-flex align-items-center">
                        <div v-if="artist.artistImage" class="me-3 d-none d-sm-block">
                          <img
                              :src="artist.artistImage"
                              class="img-fluid"
                              style="width: 50px; height: 50px; object-fit: cover; border-radius: 50%;"
                              :alt="artist.artistName ? ('Portræt af ' + artist.artistName) : 'Kunstner portræt'"
                              loading="lazy"
                              decoding="async"
                          />
                        </div>
                        <div v-else class="me-3 d-none d-sm-block">
                          <div class="bg-light d-flex align-items-center justify-content-center"
                               style="width: 50px; height: 50px; border-radius: 50%;">
                            <i class="lni lni-user fs-lg"></i>
                          </div>
                        </div>

                        <div class="flex-grow-1" style="line-height: 1.2; min-width: 0;">
                          <h2 class="fs-md ft-bold mb-0 lh-1 text-truncate" v-html="artist.artistName"></h2>
                          <span class="text-muted smalls text-truncate" v-html="artist.artistShortDescription"></span>
                        </div>
                      </div>
                    </router-link>
                  </li>
                </template>
              </ul>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="clearfix"></div>
  </div>
</template>

<script setup>
import { useRoute, useRouter } from 'vue-router' // Import useRouter
import { computed, onMounted, onUnmounted, ref, watch } from 'vue';
import logo from '@/assets/img/logo.avif'
import { Categories } from '@/data/data';
import { fetchArtists, registerSearch } from '@/services/api';

let route = useRoute()
const router = useRouter() // Initialize router
const current = computed(() => route.path)
let windowWidth= ref(window.innerWidth);
let toggle = ref(false);

// --- CHANGE 1: Added this ref ---
const mobileArtistsOpen = ref(false);

const searchTerm = ref('');

const artistResults = ref([]);
const isSearchingArtists = ref(false);
let debounceTimer = null;

watch(searchTerm, (newTerm) => {
  clearTimeout(debounceTimer);
  const term = newTerm.toLowerCase().trim();

  if (term.length < 2) {
    artistResults.value = [];
    isSearchingArtists.value = false;
    return;
  }
  isSearchingArtists.value = true;

  debounceTimer = setTimeout(async () => {
    try {
      const results = await fetchArtists({ q: term });
      if (searchTerm.value.length >= 2) {
        artistResults.value = results;
      }
    } catch (err) {
      console.error("Error searching artists:", err);
      artistResults.value = [];
    } finally {
      isSearchingArtists.value = false;
    }
  }, 300);
});

const groupedResults = computed(() => {
  const term = searchTerm.value.toLowerCase().trim();
  if (term.length < 2) {
    return [];
  }
  const groupsMap = new Map();
  for (const category of Categories) {
    const categoryNameLower = category.displayname.toLowerCase();
    let mainCategoryMatch = categoryNameLower.includes(term);
    const subcategoryMatches = [];
    let hasSubcategoryMatch = false;
    for (const subCat of category.subCategories) {
      const subCatNameLower = subCat.displayname.toLowerCase();
      if (subCatNameLower.includes(term)) {
        subcategoryMatches.push({
          type: 'subcategory',
          displayname: subCat.displayname,
          url: `/shop/${category.name}/${subCat.urlSlug}`,
          id: `${category.id}-${subCat.id}`,
        });
        hasSubcategoryMatch = true;
      }
    }
    if (mainCategoryMatch || hasSubcategoryMatch) {
      if (!groupsMap.has(category.id)) {
        groupsMap.set(category.id, {
          categoryId: category.id,
          categoryName: category.displayname,
          results: []
        });
      }
      const group = groupsMap.get(category.id);
      group.results.push({
        type: 'category',
        displayname: category.displayname,
        url: `/shop/${category.name}/${category.subCategories[0].urlSlug}`,
        id: category.id,
      });
      group.results.push(...subcategoryMatches);
      const uniqueResults = [];
      const seenIds = new Set();
      for (const res of group.results) {
        if (!seenIds.has(res.id)) {
          uniqueResults.push(res);
          seenIds.add(res.id);
        }
      }
      group.results = uniqueResults;
    }
  }
  return Array.from(groupsMap.values()).sort((a, b) => a.categoryId - b.categoryId);
});

// Clear state and navigate
const clearSearch = () => {
  searchTerm.value = "";
  artistResults.value = [];
  isSearchingArtists.value = false;
  clearTimeout(debounceTimer);
};

// Handle category click
const selectResult = (category) => {
  registerSearch("category:"+category.url)
  clearSearch();
};

// Handle artist click
const selectArtist = (artist) => {
  registerSearch("artist:"+artist.artistSubdomain)
  clearSearch();
};

// --- NEW SEARCH SUBMIT HANDLER ---
const handleSearchSubmit = () => {
  registerSearch("search:"+searchTerm.value.trim())
  const query = searchTerm.value.trim();
  if (query) {
    // Navigate to the shop page with the search query
    router.push({ path: '/shop', query: { search: query } });

    // Clear the search bar and results in the header
    clearSearch();
  }
};

const handleScroll = () => {
  const navbar = document.querySelector("#header")
  if (!navbar) return
  if (window.scrollY >= 50) {
    navbar.classList.add("header-fixed")
  } else {
    navbar.classList.remove("header-fixed")
  }
}

const handleResize = () => {
  windowWidth.value = window.innerWidth;
};

onMounted(()=>{
  window.scrollTo(0,0)
  window.addEventListener('scroll', handleScroll);
  window.addEventListener('resize', handleResize);
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll);
  window.removeEventListener('resize', handleResize);
});
</script>